// extracted by mini-css-extract-plugin
module.exports = {"btnbtn":"OrderCar_btnbtn__32kBe","divbtn":"OrderCar_divbtn__3ba4i","register":"OrderCar_register__KvNLJ","ticket":"OrderCar_ticket__2NSSI","total":"OrderCar_total__1Zx81"};